import React, { useEffect, useRef, useState } from "react";
import EasyBinTransfer_Breadcrumbs from "../../EasyBinTransfer_Breadcrumbs";
import { Grid } from "@mui/material";
import {
  CmpButton,
  CmpDatePickerField,
  CmpInputField,
  CmpSelectField,
  CmpTypographyField,
} from "../../../../Component/Common/ToolBox/ToolBox";
import { useDispatch, useSelector } from "react-redux";
import {
  EasyBinTransfer_BaseQty,
  EasyBinTransfer_Unit,
  Src_Set,
} from "../../SliceEasyBinTransfer";
import { useNavigate } from "react-router-dom";
import {
  GetItem,
  GetDelete,
  GetSrc,
  fBinNameFromKey,
  fIsEnable,
} from "../../EasyBinTransferAction";
import GCToggleSearch from "../../../../Component/Common/ReuseableComponent/GCToggleSearch";
import {
  Get_ToggleDropDown_binsearch_Load,
  fAlertToast,
  fcovertToNumber,
} from "../../../../Utility/Utilitys";
import GCMultipleCard from "../GCMultipleCard";
import { KernCAConfig, RoEasyBinTransfer } from "../../../../Redux/roStore";
import { fExecuteAPI } from "../../../../Server/Apis";

export default function EasyCardIdTransfer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [sUnitData, setUnitDataArr] = useState([]);

  const vRdxSrc = useSelector((state) => state.SliceEasyBinTransfer.value.Src);

  const onChangeInput = (e) => {
    dispatch(
      Src_Set({
        ...vRdxSrc,
        [e.target.name]: e.target.value,
      })
    );
  };
  const fBaseQty = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);

    dispatch(
      EasyBinTransfer_BaseQty({
        BaseQty: vBaseQty,
      })
    );
  };
  const fQty = (e) => {
    if (e.target.value >= 0) {
      dispatch(
        Src_Set({
          ...vRdxSrc,
          [e.target.name]: e.target.value,
        })
      );
    }
  };

  const fUnit = (e) => {
    var vUnit = sUnitData.find((obj) => {
      return obj.Unit == e.target.value;
    });
    dispatch(
      Src_Set({
        ...vRdxSrc,
        UnitCode: vUnit.Unit,
        PackQty: vUnit.PackQty,
      })
    );

    // setPackQty(vUnit.PackQty);
  };
  // multicard Start
  const [sMultipleCardModal, setMultipleCardModal] = useState(false);
  const [sMultipleCardData, setMultipleCardData] = useState([]);

  const MultiCardFlag = () => {
    const { DBKernObj } = KernCAConfig(); 
    const iShowField = DBKernObj.MULT_CARD_ID?.Val === "Y";
    if (iShowField) {
      return true;
    } else {
      return false;
    }
  };

  //api ITEM_UNIT_INSTANTPICKING_GETROW
  const GetUnitArr = async (xItemCode) => {
    const UnitInfo = await fExecuteAPI(
      "ITEM_UNIT_INSTANTPICKING_GETROW",
      xItemCode
    );
    if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
      if (UnitInfo.ResultSet.length > 0) {
        setUnitDataArr(UnitInfo.ResultSet);
        return UnitInfo.ResultSet;
      }
    } else {
      setUnitDataArr([]);
      fAlertToast(
        "FAILED",
        "Error in UnitArr" ||
          UnitInfo.Message ||
          UnitInfo?.Type.response.data.message
      );
      return [];
    }
  };

  const fItemcodeDep = async (xItmCd, xunit) => {
    let xUnitArr = await GetUnitArr(xItmCd);
    if (xUnitArr.length > 0) {
      var vUnit = xUnitArr.find((obj) => {
        return obj.Unit == xunit;
      });
      if (!!vUnit) {
        dispatch(
          EasyBinTransfer_Unit({
            UnitCode: vUnit.Unit,
            PackQty: vUnit.PackQty,
          })
        );
        fBaseQty(vRdxSrc.Qty, vUnit.PackQty);
      } else {
        dispatch(
          EasyBinTransfer_Unit({
            UnitCode: xUnitArr[0].Unit,
            PackQty: xUnitArr[0].PackQty,
          })
        );
        fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
        fBaseQty(vRdxSrc.Qty, xUnitArr[0].PackQty);
      }
    }
  };

  const GetCartIDDetail = async (xCardId = vRdxSrc.CardId) => {
    let vCardIDObj = {
      v_CardID: xCardId,
    };
    const cardIdInfo = await fExecuteAPI("BIN_TRANSFER_CARD_ID", vCardIDObj);
    if (cardIdInfo.Type?.toUpperCase() === "SUCCESS") {
      if (cardIdInfo?.ResultSet?.length > 0) {
        setMultipleCardModal(false);
        dispatch(
          Src_Set({
            ...vRdxSrc,
            ItemCode: cardIdInfo.ResultSet[0].ItmCd,
            ItemName: cardIdInfo.ResultSet[0].Name2,
            CardId:xCardId,
          })
        );
        if (cardIdInfo.ResultSet[0].ItmCd !== "") {
          fItemcodeDep(
            cardIdInfo.ResultSet[0].ItmCd,
            cardIdInfo.ResultSet[0].Unit
          );
        }
        document.getElementById("qty")?.focus();
      } else {
        dispatch(
          Src_Set({
            ...vRdxSrc,
            ItemCode: "",
            ItemName: "",
            UnitCode: "",
            UnitName: "",
            PackQty: 0,
          })
        );

        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (cardIdInfo.Type?.toUpperCase() === "FAILED") {
      // setBinTransferObj((obj) => ({ ...obj, cardId: "" }));
      fAlertToast("FAILED", cardIdInfo.Message);
    }
  };

  const GetBarcodeDetail = async (xBarcode = vRdxSrc.CardId) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_Loc: vRdxSrc.LocCode,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length > 0) {
        dispatch(
          Src_Set({
            ...vRdxSrc,
            ItemCode: vBarcodeDetail.ResultSet[0].ItmCd,
            ItemName: vBarcodeDetail.ResultSet[0].Name2,
            CardId: vBarcodeDetail.ResultSet[0].CardID,
          })
        );
        if (vBarcodeDetail.ResultSet[0].ItmCd !== "") {
          fItemcodeDep(
            vBarcodeDetail.ResultSet[0].ItmCd,
            vBarcodeDetail.ResultSet[0].Unit
          );
        }
        setTimeout(() => {
          document.getElementById("Qty")?.focus();
        }, 100);
      } else {
        dispatch(
          Src_Set({
            ...vRdxSrc,
            ItemCode: "",
            ItemName: "",
            UnitCode: "",
            UnitName: "",
            PackQty: 0,
          })
        );
        fAlertToast("WARNING", "Wrong barcode Id");
      }
    } else {
      fAlertToast(
        "FAILED",
        "Error in Loading Barcode " ||
          vBarcodeDetail.Message ||
          vBarcodeDetail.response.data.message
      );
    }
  };
  const GetMultiBarcodeDetail = async (
    xBarcode = vRdxSrc.CardId,
    xBinCd = vRdxSrc.BinCodeFrom
  ) => {
    let { Src } = RoEasyBinTransfer();
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_BinCd: xBinCd,
      v_Loc: Src.LocCode,
      v_VocTyp: Src.DocTypCode,
      v_VocNo: Src.DocNo,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_MULTI_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length == 0) {
        dispatch(
          Src_Set({
            ...vRdxSrc,
            ItemCode: "",
            ItemName: "",
            UnitCode: "",
            UnitName: "",
            PackQty: 0,
          })
        );
        fAlertToast("WARNING", "Wrong Barcode Id");
      } else if (vBarcodeDetail.ResultSet.length == 1) {
        GetCartIDDetail(vBarcodeDetail?.ResultSet[0]?.CARDID);
      } else if (vBarcodeDetail.ResultSet.length > 1) {
        setMultipleCardData(vBarcodeDetail.ResultSet);
        setMultipleCardModal(true);
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail.response.data.message ||
          vBarcodeDetail.Message ||
          "Error in Loading MultiBarcode "
      );
      return;
    }
  };
  const GetCard = async (e) => {
    let { Src } = RoEasyBinTransfer();
    // if (vRdxSrc.ItemCode != "") {
    //   document.getElementById("Next").click();
    // }
    if (e.key === "Enter") {
      if (Src.CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      }
      if (Src.BinCodeFrom == "" || Src.BinNameFrom == "") {
        fAlertToast("FAILED", "BinCode is empty");
        setTimeout(() => {
          document.getElementById("BinNameFrom")?.focus();
        }, 100);
      } else if (MultiCardFlag()) {
        GetMultiBarcodeDetail(Src.CardId, Src.BinCodeFrom);
      } else if (Src.BinCodeFrom !== "" && Src.BinNameFrom !== "") {
        const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
          Src.BinNameFrom,
          "Any",
          "Y",
          Src.LocCode
        );
        if (vReasonWmBin.length > 0 && vReasonWmBin[0]?.OpenBin == "Y") {
          GetBarcodeDetail(Src.CardId);
        } else {
          GetCartIDDetail(Src.CardId);
        }
      }
    } else if (
      e.key === "Backspace" ||
      (e.key === "Delete" && Src.CardId == "")
    ) {
      dispatch(
        Src_Set({
          ...vRdxSrc,
          ItemCode: "",
          ItemName: "",
          UnitCode: "",
          UnitName: "",
          PackQty: 0,
        })
      );
      setUnitDataArr([]);
    }
  };
  // multicard end
  const xfocus = (e) => {
    document.getElementsByName("CardId")[0]?.focus();
  };
  const FocusOnLoad = useRef(null);
  useEffect(() => {
    FocusOnLoad.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (vRdxSrc.DocNo != "") {
      GetUnitArr(vRdxSrc.ItemCode);
      // fItemcodeDep(vRdxSrc.ItemCode, vRdxSrc.UnitCode);
    }
  }, []);
  useEffect(() => {
    fBaseQty(vRdxSrc.Qty, vRdxSrc.PackQty);
  }, [vRdxSrc.Qty, vRdxSrc.PackQty]);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex my-3">
        <EasyBinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferData">
          <div className="gridStyle">
            <Grid
              container
              columnSpacing={1}
              rowSpacing={2}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans ID"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"DocNo"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.DocNo}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans Date"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpDatePickerField
                  xValue={vRdxSrc.Date}
                  xOnChange={(newValue) =>
                    dispatch(
                      Src_Set({
                        ...vRdxSrc,
                        Date: newValue.$d,
                      })
                    )
                  }
                  xName={"Date"}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpSelectField
                  xValue={vRdxSrc.LocCode}
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"LocCode"}
                  xData={vRdxuserLoc}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Bin From"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinCodeFrom"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.BinCodeFrom}
                />
              </Grid> */}
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <GCToggleSearch
                  xref={FocusOnLoad}
                  xtabIndex={"25"}
                  xName={"BinNameFrom"}
                  xType={"text"}
                  xValue={vRdxSrc.BinNameFrom}
                  xOnKeyUp={async (e) => {
                    await fBinNameFromKey(e, dispatch, xfocus);
                  }}
                  xReadOnly={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await fBinNameFromKey(e, dispatch, xfocus);
                  }}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Card Id"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"CardId"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.CardId}
                /> */}
                <GCToggleSearch
                  xtabIndex={"25"}
                  xName={"CardId"}
                  xType={"text"}
                  xValue={vRdxSrc.CardId}
                  xOnKeyUp={async (e) => {
                    await GetCard(e);
                  }}
                  xReadOnly={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await GetCard(e);
                  }}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Item"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"ItemCode"}
                  xReadOnly={true}
                  xOnChange={""}
                  xValue={vRdxSrc.ItemCode}
                />
              </Grid> */}
              <Grid item  xs={8} sm={9} md={8} lg={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"ItemName"}
                  xValue={vRdxSrc.ItemName}
                  xReadOnly={true}
                  xOnChange={() => {}}
                /> */}
                <GCToggleSearch
                  xtabIndex={"25"}
                  xName={"ItemName"}
                  xType={"text"}
                  xValue={vRdxSrc.ItemName}
                  xOnKeyUp={async (e) => {
                    if (e.key === "Enter" || e?._reactName === "onClick") {
                      await GetItem(dispatch);
                    }
                    if (
                      e.key === "Backspace" ||
                      (e.key === "Delete" && vRdxSrc.ItemName == "")
                    ) {
                      dispatch(
                        Src_Set({
                          ...vRdxSrc,
                          ItemCode: "",
                        })
                      );
                    }
                  }}
                  xReadOnly={true}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await GetItem(dispatch);
                  }}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Qty"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"Qty"}
                  xReadOnly={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                  xOnChange={fQty}
                  xValue={vRdxSrc.Qty}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Unit"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"UnitCode"}
                  xReadOnly={true}
                  xOnChange={fUnit}
                  xValue={vRdxSrc.UnitCode}
                /> */}
                <CmpSelectField
                  xLabelText="Unit"
                  xValue={vRdxSrc.UnitCode}
                  xOnChange={fUnit}
                  xName={"UnitCode"}
                  xData={sUnitData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"BaseQty"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BaseQty"}
                  xReadOnly={true}
                  xOnChange={() => {}}
                  xValue={vRdxSrc.BaseQty}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className="mt-2"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={async () => {
                    await GetDelete(navigate);
                  }}
                  xDisabled={fIsEnable()}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                  xbtnName="Next"
                  xId="Next"
                  xOnClick={async () => {
                    if (vRdxSrc.BinCodeFrom == "") {
                      fAlertToast("FAILED", "Bin From Should not be empty");
                      return;
                    } else if (vRdxSrc.ItemCode == "") {
                      fAlertToast("FAILED", "Item Code Should not be empty");
                      return;
                    } else if (vRdxSrc.CardId == "" || vRdxSrc.CardId == 0) {
                      fAlertToast("FAILED", "Card Id Should not be empty");
                      return;
                    } else if (vRdxSrc.Qty == "") {
                      fAlertToast("FAILED", "Qty Should not be empty");
                      return;
                    } else if (vRdxSrc.UnitCode == "") {
                      fAlertToast("FAILED", "UnitCode Should not be empty");
                      return;
                    } else {
                      if (vRdxSrc.DocNo == 0) {
                        let resp = await GetSrc(dispatch);
                        resp.length > 0 &&
                          navigate("/EasyCardIdTransferDetail");
                      } else {
                        navigate("/EasyCardIdTransferDetail");
                      }
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <GCMultipleCard
        xOpen={sMultipleCardModal}
        fCloseDetailModal={() => {
          setMultipleCardModal(false);
        }}
        sMultipleCard={sMultipleCardData}
        xTitle={"Card Detail"}
        onClickMultipleCard={async (obj) => {
          await GetCartIDDetail(obj.CARDID);
        }}
      />
    </div>
  );
}
